/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

const timeFormat = new Intl.DateTimeFormat(undefined, {
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit",
});

export function runTime(iso: string | null): string {
  if (iso === null) {
    return "—";
  }
  const parsed = new Date(iso);
  return Number.isNaN(parsed.getTime()) ? iso : timeFormat.format(parsed);
}

const slotDayFormat = new Intl.DateTimeFormat(undefined, {
  weekday: "short",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
});

const slotEndFormat = new Intl.DateTimeFormat(undefined, {
  hour: "numeric",
  minute: "2-digit",
});

export function formatSlot(startIso: string | null, endIso: string | null): string {
  if (startIso === null) {
    return "no slot attached";
  }
  const start = new Date(startIso);
  if (Number.isNaN(start.getTime())) {
    return startIso;
  }
  const startText = slotDayFormat.format(start);
  if (endIso === null) {
    return startText;
  }
  const end = new Date(endIso);
  return Number.isNaN(end.getTime()) ? startText : `${startText} to ${slotEndFormat.format(end)}`;
}

export function triggerLabel(trigger: string): string {
  switch (trigger) {
    case "WEBHOOK_INTAKE_CANCELLED":
      return "Intake cancelled";
    case "MANUAL":
      return "Started by staff";
    default:
      return trigger.replaceAll("_", " ").toLowerCase();
  }
}

export function runStatusLabel(status: string): string {
  switch (status) {
    case "COMPLETED_BOOKED":
      return "Booked";
    case "COMPLETED_FALLBACK":
      return "Handed off";
    case "FAILED":
      return "Failed";
    case "RUNNING":
      return "Running";
    default:
      return status.replaceAll("_", " ").toLowerCase();
  }
}

/** Status dot, on the discipline: green only for a booking, red for failure, neutral otherwise. */
export function runStatusDot(status: string): string {
  switch (status) {
    case "COMPLETED_BOOKED":
      return "bg-success";
    case "FAILED":
      return "bg-error";
    default:
      return "bg-text-tertiary";
  }
}
